var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 5.3125V0H1.4375C0.917969 0 0.5 0.417969 0.5 0.9375V19.0625C0.5 19.582 0.917969 20 1.4375 20H14.5625C15.082 20 15.5 19.582 15.5 19.0625V6.25H10.1875C9.67188 6.25 9.25 5.82812 9.25 5.3125ZM11.75 14.5312C11.75 14.7891 11.5391 15 11.2812 15H4.71875C4.46094 15 4.25 14.7891 4.25 14.5312V14.2188C4.25 13.9609 4.46094 13.75 4.71875 13.75H11.2812C11.5391 13.75 11.75 13.9609 11.75 14.2188V14.5312ZM11.75 12.0312C11.75 12.2891 11.5391 12.5 11.2812 12.5H4.71875C4.46094 12.5 4.25 12.2891 4.25 12.0312V11.7188C4.25 11.4609 4.46094 11.25 4.71875 11.25H11.2812C11.5391 11.25 11.75 11.4609 11.75 11.7188V12.0312ZM11.75 9.21875V9.53125C11.75 9.78906 11.5391 10 11.2812 10H4.71875C4.46094 10 4.25 9.78906 4.25 9.53125V9.21875C4.25 8.96094 4.46094 8.75 4.71875 8.75H11.2812C11.5391 8.75 11.75 8.96094 11.75 9.21875ZM15.5 4.76172V5H10.5V0H10.7383C10.9883 0 11.2266 0.0976562 11.4023 0.273438L15.2266 4.10156C15.4023 4.27734 15.5 4.51562 15.5 4.76172Z",
    fill: "#668598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoice-icon.aec0394875b44f300b8a6e05081f5636.svg";
export { ForwardRef as ReactComponent };